
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import StumpGrinding from "../pages/stump-grinding/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/stump-grinding",
    element: <StumpGrinding />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
